var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container justify-content-center",
      class: { "pt-5 pb-5": _vm.resultPage.isMobile === true },
    },
    [_c("div", { staticClass: "feedback-full" }, [_c("feedback-full")], 1)]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }